export default __webpack_public_path__ + "static/media/spring-drg-logo.b3235e6e.png";